document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".split-fill-text").forEach((button) => {
    // Split the neutral button text into words
    const neutralSplit = new SplitText(button, { type: "words", wordsClass: "word" });
    const words = neutralSplit.words;

    // Create the gradient text layer per word (visually on top)
    words.forEach((word) => {
      const gradientSpan = document.createElement("span");
      gradientSpan.classList.add("gradient-text");
      gradientSpan.innerHTML = word.innerHTML; // Copy original word text exactly
      word.appendChild(gradientSpan);
    });

    // GSAP Timeline animation using ScrollTrigger, smoothly fading in gradient text
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: button,
        start: "top 70%",
        toggleActions: "play none none none",
        once: true,
        onEnter: () => button.classList.add("filled"),
      },
    });

    // Animate gradient text sequentially word-by-word (opacity)
    tl.to(
      words.map((word) => word.querySelector(".gradient-text")),
      {
        opacity: 1,
        ease: "power2.out",
        duration: 0.6,
        stagger: 0.2,
      }
    );
  });
});
